(function() {
    'use strict';

    document.addEventListener('alpine:init', () => {
        Alpine.data('productFamily', (variations, activeId) => {
            const initial = variations.find(v => v.id === activeId);

            return {
                variations,
                activeId,
                activeImage: initial ? initial.image : '',
                activeTitle: initial ? initial.title : '',
                activeLink: initial ? initial.permalink : '',
                flyoutOpen: false,
                scrollTop: 0,

                setVariation(v) {
                    this.activeId = v.id;
                    this.activeImage = v.image;
                    this.activeTitle = v.title;
                    this.activeLink = v.permalink;
                },

                openFlyout() {
                    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                    document.documentElement.style.setProperty(
                        '--site-scroll-top',
                        this.scrollTop + 'px',
                    );

                    document.documentElement.classList.add('flyout--open');
                    this.flyoutOpen = true;
                },

                closeFlyout() {
                    this.flyoutOpen = false;

                    setTimeout(() => {
                        document.documentElement.classList.remove('flyout--open');
                        document.documentElement.style.setProperty(
                            '--site-scroll-top',
                            '0px',
                        );
                        document.documentElement.scrollTo(0, this.scrollTop);
                        this.scrollTop = 0;
                    }, 300);
                },
            };
        });
    });
}());
